import 'swiper/css/bundle';
import './master-carousel.css';
import Swiper from 'swiper';
import { FreeMode, Navigation } from 'swiper/modules';

const slideSwiper = {};
const carouselSections = [
  'section-1688315940840', // New releases
  'section-1710326991754', // Ballet
  'section-1710331021632', // Contemporary
  'section-1710331056643', // For beginners
  'section-1710331074042', // Dance education
];

function handleMasterCarousel() {
  if (document.readyState !== 'complete' || !window.jQuery) {
    setTimeout(handleMasterCarousel, 30); // try again
    return;
  }

  // master sections
  carouselSections.forEach((id) => {
    $(`#${id} .feature`).has('img').addClass('master-feature');
    initCarouselForContainer(id);
  });
}

function initCarouselForContainer(containerId) {
  const features = $(`#${containerId} .master-feature`);
  const slides = features.parent().parent(); // block

  // Add swiper-slide class to each feature block
  slides.addClass('swiper-slide');

  // Required wrapper for the slides
  slides.wrapAll('<div class="swiper-wrapper"></div>');

  // Required container for the swiper
  $(`#${containerId} .swiper-wrapper`).wrap('<div class="swiper"></div>');

  const swiperContainer = $(`#${containerId} .swiper`);

  // Navigation arrows
  swiperContainer.after(`<div class="swiper-button-prev"></div>`);
  swiperContainer.after(`<div class="swiper-button-next"></div>`);

  slideSwiper[containerId] = new Swiper(`#${containerId} .swiper`, {
    modules: [Navigation, FreeMode],
    slidesPerView: 1.5,
    spaceBetween: 10,
    breakpoints: {
      577: {
        slidesPerView: 2.5,
        spaceBetween: 20,
        slidesPerGroup: 2,
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 20,
        slidesPerGroup: 3,
      },
      1024: {
        slidesPerView: 4.5,
        spaceBetween: 20,
        slidesPerGroup: 4,
      },
    },
    freeMode: {
      enabled: true,
    },
    navigation: {
      nextEl: `#${containerId} .swiper-button-next`,
      prevEl: `#${containerId} .swiper-button-prev`,
    },
  });
}

handleMasterCarousel();
